import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchSuppliers,
  fetchSupplierByID,
  filterSuppliers,
  selectSuppliers,
  fetchMoreSuppliers,
  getFullList,
} from "./suppliersSlice";

import Grid from "@material-ui/core/Grid";
import SuppliersList from "./SupplierList";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function SuppliersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");

  const dispatch = useDispatch();
  const classes = useStyles();

  const [supplierNames, setSupplierNames] = useState([]);
  const [supplierIDs, setSupplierIDs] = useState([]);
  const [ready, setReady] = useState(false);

  const { suppliers, loading, suppliersList, lastQuery, suppliersAmount } =
    useSelector(selectSuppliers);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const handleSuppliersChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedSupplier = suppliersList.filter(
      (supplier) => supplier.name === event.target.value
    );
    selectedSupplier && idsArr.push(selectedSupplier[0].id);
    // });

    setSupplierNames(event.target.value);
    setSupplierIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchSuppliers({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > suppliersList.length
            ? rowsPerPage
            : suppliersList.length,
        query: searchQuery,
        targetLength: suppliersAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        suppliersList.length < suppliersAmount &&
        suppliersList.length < expectedLen
      ) {
        dispatch(
          fetchMoreSuppliers({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (suppliersList.length == suppliersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchSuppliers({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (supplierIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "suppliers",
        supplierIDs.join(",")
      );
    }

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchSuppliers({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setSupplierNames([]);
    setSupplierIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setSortDirection(null);
    setSortProperty(null);
    setSearchTerm("");

    dispatch(
      fetchSuppliers({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };
  const handleEditClick = (id) => {
    dispatch(
      fetchSupplierByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const selectNames = ["status"];

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Supplier #",
      long: true,
      sortable: true,
    },
    {
      id: "name",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Name",
      long: true,
      sortable: true,
    },

    {
      id: "description",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Description",
      long: true,
    },
    {
      id: "xeroID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Xero Contact ID",
      long: true,
    },
    {
      id: "emailAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Email",
      long: false,
      sortable: true,
    },
    {
      id: "phone_number",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Phone",
      long: false,

    },
    {
      id: "mobileNumber",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Mobile",
      long: false,
 
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Updated",
      long: false,
      sortable: true,
    },
    {
      id: "statusID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Status",
      long: false,
      sortable: true,
    },
  ];
  const [rowList, setRowList] = useState([...headCells]);

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <SuppliersList
        suppliers={suppliers}
        handleSuppliersChange={handleSuppliersChange}
        supplierNames={supplierNames}
        supplierIDs={supplierIDs}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        filterNames={supplierNames}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={suppliersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
